import React from "react"
import styles from "./validation-message.module.css"
interface ValidationMessageProp {
    name: string,
    value: any,
    errors: any,
    register: any,
    message: string

}
interface ValidationMessageProp {
    name: string,
    value: any,
    errors: any,
    register: any,
    message: string,
    min?: number

}

const RequiredMessage = (prop: ValidationMessageProp) => {
    if (!prop.name || typeof prop.name !== 'string' || !prop.register || typeof prop.register !== 'function') {
        return null;
    }
    const safeValue = prop.value != null ? String(prop.value) : "";
    const safeName = String(prop.name);
    try {
        return (
            <>
                <input
                    className="hidden"
                    name={safeName}
                    readOnly
                    ref={prop.register({ required: true, minLength: 1 })}
                    value={safeValue}
                />
                {prop.errors && prop.errors[safeName] && <p className={styles.message}>{prop.message}</p>}
            </>
        )
    } catch (error) {
        console.error('RequiredMessage error:', error);
        return null;
    }
}
const MinValidateMessage = (prop: ValidationMessageProp) => {
    if (!prop.name || typeof prop.name !== 'string' || !prop.register || typeof prop.register !== 'function') {
        return null;
    }
    const safeValue = prop.value != null ? String(prop.value) : "";
    const safeName = String(prop.name);
    try {
        return (
            <>
                <input
                    className="hidden"
                    name={safeName}
                    readOnly
                    ref={prop.register({ required: true, minLength: 1, min: prop.min ? prop.min : 1 })}
                    value={safeValue}
                />
                {prop.errors && prop.errors[safeName] && <p className={styles.message}>{prop.message}</p>}
            </>
        )
    } catch (error) {
        console.error('MinValidateMessage error:', error);
        return null;
    }
}
export { RequiredMessage, MinValidateMessage }